export default __webpack_public_path__ + "images/NY.6691e3d.png";